// extracted by css-extract-rspack-plugin
export default {"wrapper":"_7538eeca","column":"_2fe5e64f"};